module.exports = __webpack_public_path__ + "932a49d9.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/src/src_img/dl_appstore_white.png
// module id = 1508
// module chunks = 0